<template>
  <div class="colspan2 d-flex justify-content-between align-items-center ">
    <div class="d-flex flex-row align-items-center">
      <h5
        class="mb-0 me-2"
      >Status:</h5>

      <material-badge
        size="sm"
        :color="reportedColor"
        @click="() => updateReportStatus(1)"
      >
        <span
          :class="{ placeholder: isLoading }"
        >Aangemeld</span>
      </material-badge>

      <material-badge
        size="sm"
        :color="inProgressColor"
        @click="() => updateReportStatus(2)"
      >
        <span
          :class="{ placeholder: isLoading }"
        >In behandling</span>
      </material-badge>

      <material-badge
        size="sm"
        :color="resolvedColor"
        @click="() => updateReportStatus(3)"
      >
        <span
          :class="{ placeholder: isLoading }"
        >Afgehandeld</span>
      </material-badge>
    </div>

    <div>
      <material-button
        v-if="updated"
        class="float-end"
        size="sm"
        @click.prevent="submit"
      >
        Opslaan
      </material-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import MaterialBadge from '../../MaterialBadge.vue';
import MaterialButton from '@/components/MaterialButton.vue';

import ReportDetailStore from '@/store/pages/Report/report-detail-store';

import { updateReport, getLogsById } from '@/api/providers/reports';

export default {
  components: {
    MaterialBadge,
    MaterialButton,
  },

  emits: [
    'update:status',
    'submitted'
  ],

  data() {
    return {
      updated: false
    }
  },

  computed: {
    report() {
      return ReportDetailStore.getters.report;
    },

    isLoading() {
      return ReportDetailStore.getters.isLoading;
    },
    
    reportedColor() {
      return this.report?.reportStatus === 1
        ? 'info'
        : 'light'
    },

    inProgressColor() {
      return this.report?.reportStatus === 2
        ? 'warning'
        : 'light'
    },

    resolvedColor() {
      return this.report?.reportStatus === 3
        ? 'success'
        : 'light'
    }
  },

  methods: {
    ...mapActions('notification', {
      addNotification: 'add',
      addError: 'addError'
    }),

    updateReportStatus(status) {
      ReportDetailStore.dispatch('updateReportStatus', status);
      this.updated = true;
    },

    async submit() {
      if (!this.updated) return;

      try {
        await this.updateReport();

        let updatedLogs = await getLogsById(
          ReportDetailStore.getters.report.id
        );

        ReportDetailStore.dispatch('updateLogItems', updatedLogs.reverse());
        
        this.updated = false;

        this.addNotification({
          description: `Status is geüpdatet.`,
          icon: {
            component: 'feedback',
          },
        });
      }
      catch {
        this.addError('Kon wijziging niet opslaan.');
      }
    },

    async updateReport() {
        await updateReport(ReportDetailStore.getters.report);
    },
  }
}
</script>

<style>
.badge {
  cursor: pointer;
}
</style>
